import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";

const SidebarItem = ({ item }) => {
    return (
        <NavLink
            to={item.path}
            end
            className={({ isActive }) =>
                `
                flex items-center gap-3 px-4 py-3 rounded-xl
                text-sm transition
                ${isActive
                    ? "text-white shadow bg-gradient-to-r from-[#543389] to-[#8b6bd9]"
                    : "text-slate-600 bg-slate-100 hover:bg-slate-200/80"}
                `
            }
        >
            <ReactSVG src={`${process.env.PUBLIC_URL}${item.icon}`} className="w-5 h-5"/>
            {item.title}
        </NavLink>
    );
};

export default SidebarItem